

































import Vue from 'vue';
import layout from '@/libs/layout/school/training';
import { Component } from 'vue-property-decorator';
import { getTrainingVideoList } from '@/api/school';
import { TTraingVideoPage } from '@/types/views/school.d.ts';
import { TLayout } from '@/types/utils';
@Component({})
export default class Traning extends Vue {
  private layout: TLayout = layout
  private traingVideoPage: TTraingVideoPage = {
    currentPage: 1,
    pageSize: 20
  };
  private mounted() {
    this.getTrainingVideoList({
      currentPage: 1,
      pageSize: 20
    });
  }
  private handleSizeChange(size: number) {
    this.getTrainingVideoList({
      data: JSON.stringify({
        currentPage: 1,
        pageSize: size
      })
    });
  }
  private handleCurrentChange(size: number) {
    this.getTrainingVideoList({
      data: JSON.stringify({
        currentPage: size,
        pageSize: this.traingVideoPage.pageSize
      })
    });
  }
  /**
   * 获取培训视频
   */
  private async getTrainingVideoList(opts: any) {
    try {
      let res: any = await getTrainingVideoList({
        data: JSON.stringify(opts)
      });
      this.traingVideoPage = res;
    } catch (e) {
      this.$message.error(e.message);
    }
  }
  /**
   * 渲染index
   * @param {number} index 列表索引
   */
  private renderIndex(index: number) {
    return (
      index +
        1 +
        (this.traingVideoPage.currentPage - 1) *
          this.traingVideoPage.pageSize || 0
    );
  }
}
